// Centralized billable-rate logic — ONE source of truth for weekly/monthly.
// A rate record from the BillableRates list looks like: { Role, Type, Rate }
// where Type is "Weekly" or "Monthly". Everything in the app should convert
// through these helpers so weekly vs. monthly is never handled ad hoc.

const WEEKS_PER_MONTH = 52 / 12; // 4.3333
const norm = (s) => (s || "").toLowerCase().replace(/[^a-z0-9]/g, "");

// Find the rate record that best matches a role (exact, then fuzzy contains).
export function rateRecordFor(role, rates) {
  const r = norm(role);
  if (!r) return null;
  let m = (rates || []).find((x) => norm(x.Role) === r);
  if (!m) m = (rates || []).find((x) => r.includes(norm(x.Role)) || norm(x.Role).includes(r));
  return m || null;
}

export function weeklyRateForRole(role, rates) {
  const rec = rateRecordFor(role, rates);
  if (!rec) return 0;
  const rate = Number(rec.Rate) || 0;
  return rec.Type === "Monthly" ? rate / WEEKS_PER_MONTH : rate;
}

export function monthlyRateForRole(role, rates) {
  const rec = rateRecordFor(role, rates);
  if (!rec) return 0;
  const rate = Number(rec.Rate) || 0;
  return rec.Type === "Weekly" ? rate * WEEKS_PER_MONTH : rate;
}

// "Weekly" | "Monthly" | null — used to label how a person's rate was entered.
export function rateTypeForRole(role, rates) {
  const rec = rateRecordFor(role, rates);
  return rec ? (rec.Type || "Weekly") : null;
}
